import jwtDecode from "jwt-decode";

import { ROLE_ADMIN, ROLE_VLN } from "constants/role";
import api, { manageError } from "config/api";

export const login = ({ email, password }) =>
  api.post("/auth/signin", { email, password });

export const sigin = async ({ email, password }) => {
  const response = await api.post("/auth/signin", { email, password });
  return manageError(response);
};

export const getUserInfo = async () => {
  const response = await api.get("/auth/me");
  return manageError(response);
};

export const signup = (user) => api.post("/auth/signup", user);

export const isAuth = () => {
  let tokenDecode = getTokenDecode();
  if (tokenDecode) {
    let tokenExpiration = tokenDecode.exp;
    let dateNow = new Date();
    if (tokenExpiration > dateNow.getTime() / 1000) {
      const tokenItem = localStorage.getItem("utk");
      api.setHeader("Authorization", `Bearer ${tokenItem}`);
      return true;
    } else logout();
  } else logout();
};

export const isAdmin = () => {
  let tokenDecode = getTokenDecode();
  if (tokenDecode) {
    let tokenRole = tokenDecode.roles;
    if (tokenRole.includes(ROLE_ADMIN)) {
      return true;
    } else return false;
  } else return false;
};

export const isVln = () => {
  let tokenDecode = getTokenDecode();
  if (tokenDecode) {
    let tokenRole = tokenDecode.roles;
    if (tokenRole === ROLE_VLN) {
      return true;
    } else return false;
  } else return false;
};

export const getTokenDecode = () => {
  const token = localStorage.getItem("utk");
  if (token) {
    return jwtDecode(token);
  } else {
    return null;
  }
};

const logout = () => {
  localStorage.removeItem("utk");
  return false;
};
